import { queryClient } from "@impero-com/common/utils/query_client";

import { getGetTestingProgramsTestingProgramIdActivitiesExportQueryOptions } from "api/generated/testing-programs/testing-programs";

export function fetchTestingActivitiesExportQuery(testingProgramId: number) {
    return queryClient.fetchQuery(
        getGetTestingProgramsTestingProgramIdActivitiesExportQueryOptions(
            testingProgramId
        )
    );
}
